/**
 * RS Go plateform v1.0.0 - React APPLICATION
 * Copyright 2017-present, My Edition Company SAS -> for RoyalSpeed SARL
 * All rights reserved.
 *
 * @authors: José Barcelon Godfrey
 * Paris, France
 */

import React, {Component, PropTypes} from 'react'
import Helmet from "react-helmet"

import f_options from './_foptions.jsx';

export default class SelectFormation extends Component {
  constructor(props) {
    super(props);
    this.assignFormation = this.assignFormation.bind(this);
  }
  assignFormation(f_id){

    var data = {
      prospect_ecole: false,
      prospect_code: false,
      prospect_year_code: null,
      prospect_formation_manu: false,
      prospect_formation_bateau: false,
      prospect_formation_avion: false,
      prospect_heure_conduite: false,
      prospect_heure_vol: false,
      prospect_heure_navigation: false,
      prospect_nb_heure_conduite: null,
      prospect_nb_heure_vol: null,
      prospect_nb_heure_navigation: null,
      prospect_permis_ppl: false,
      prospect_permis_statut: null,
      prospect_preference_pass: null,
      prospect_preference_contact: null,
      prospect_message: null,
      prospect_firstname: null,
      prospect_lastname: null,
      prospect_email: null,
      prospect_phone: null,
      prospect_formation: null
    }

    this.props.saveValues(data)
    this.props.assignFormation(f_id);
  }
  render() {
    var that = this;
    var groupSize = 3;
    var otherOptions = Object.keys(f_options.other).map(function(o, i) {
      var optionValue = f_options.other[o];
      var descLines = optionValue.description.split(/\n/);
      return  <div className="one-third column" key={'fopt_other_'+i}>
          <div className={"go-card formation-option "+(that.props.f == optionValue.id ? "selected" : "")} onClick={() => {that.assignFormation(optionValue.id)}}>
            <div className={"option-graphic "+optionValue.icon}>
            </div>
            <div>
              <h2>{optionValue.name}</h2>
              {
                descLines.map(function(line, i){
                  return <p key={optionValue.icon+'_'+i}>{line}</p>
                })
              }
            </div>
          </div>
        </div>;
    }).reduce(function(r, element, index) {
        index % groupSize === 0 && r.push([]);
        r[r.length - 1].push(element);
        return r;
    }, []).map(function(rowContent, i) {
        return <div className="row" key={'row_'+i}>{rowContent}</div>;
    });
    return <div className="go-form-step">
      <div className="go-step-header">
        {that.props.f ? <button className="go-button go-green pull-right" onClick={() => {this.props.next(1)}}>Go</button> : null}
        
        <h1>1. Sélectionnez votre formation</h1>
      </div>
      <div className="row">
        {Object.keys(f_options.main).map(function (i, idx) {
          var optionValue = f_options.main[i];
          var descLines = optionValue.description.split(/\n/);
          return <div className="one-third column" key={'fopt_main_'+i}>
                  <div className={"go-card formation-option larger "+(that.props.f == optionValue.id ? "selected" : "")} onClick={() => {that.assignFormation(optionValue.id)}}>
                    <div className={"option-graphic "+optionValue.icon}>
                    </div>
                    <div>
                      <h2>{optionValue.name}</h2>
                      {
                        descLines.map(function(line, i){
                          return <p key={optionValue.icon+'_'+i}>{line}</p>
                        })
                      }
                    </div>
                  </div>
                </div>
        })}
      </div>
      <div className='center-text'>
        <h5 style={{margin: 10}}>autres formations :</h5> 
      </div>
      {otherOptions}

      <div className='center-text' style={{margin: 10}}>
        {that.props.f ? <button className="go-button go-action" onClick={() => {this.props.next(1)}}>Go</button> : null}
      </div>
    </div>
  }
}


// WEBPACK FOOTER //
// ./go/views/components/signup/formation.jsx